<template>
  <b-modal
    :active.sync="show"
    trap-focus
    aria-role="dialog"
    scroll="keep"
    :width="1000"
    :height="600"
    aria-modal
    has-modal-card
    @close="closeModal"
  >
    <ValidationObserver ref="observer" v-slot="{ passes }">
      <form @submit.prevent="passes(save)">
        <div class="modal-card">
          <header class="modal-card-head">
            <p class="modal-card-title">Change Manual QC Status</p>
          </header>
          <section class="modal-card-body">
            <div>
              <BaseSelect
                v-model="item.manualqcstatus"
                label="Status"
                :rules="'required'"
              >
                <option value="pass">Pass</option>
                <option value="fail">Fail</option>
              </BaseSelect>
            </div>
            <div>
              <BaseInput
                v-model="item.statuscomment"
                label="Feedback"
                type="textarea"
                :rules="item.manualqcstatus === 'fail' ? 'required' : ''"
              />
            </div>
          </section>
          <footer class="modal-card-foot" style="display: block">
            <button class="button" type="button" @click="closeModal">
              Cancel
            </button>
            <button class="button is-primary" type="button" @click="save">
              Update
            </button>
          </footer>
        </div>
      </form>
    </ValidationObserver>
  </b-modal>
</template>

<script>
import BaseSelect from '@/components/BaseSelect'
import MediaApi from '@/api/media'
import EpisodeApi from '@/api/episodes'

export default {
  name: 'ChangeManualQCStatusModal',
  components: {
    BaseSelect,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    isEpisode: {
      type: Boolean,
      default: false,
    },
    media: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      loading: false,
      initialized: false,
      showModal: this.show,
      item: {},
    }
  },
  async created() {
    this.initialized = true
  },
  async mounted() {
    this.item = this.media
  },
  methods: {
    async save() {
      if (this.isEpisode) {
        EpisodeApi.updateManualQCStatus({
          episodeId: this.item.id,
          mediaId: this.item.media_id,
          status: this.item.manualqcstatus,
          comment: this.item.statuscomment,
        })
      } else {
        await MediaApi.updateManualQCStatus({
          mediaId: this.item.id,
          status: this.item.manualqcstatus,
          comment: this.item.statuscomment,
        })
      }

      this.$buefy.toast.open({
        message: 'Manual QC status updated successfully!',
        position: 'is-top',
        type: 'is-success',
      })
      this.closeModal()
      this.$emit('refresh')
    },
    closeModal() {
      this.showModal = false
      this.$emit('close-modal')
    },
  },
}
</script>
